import { Button } from 'antd';
import styled, { css } from 'styled-components';

const StyledButton = styled(Button)`
  align-items: center;
  justify-content: center;
  font-weight: 500;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  ${({ type, ghost }) => {
    if (ghost) {
      switch (type) {
        case 'primary':
          return css`
            color: ${({ theme }) => theme.colors.brand.primary};
            background-color: ${({ theme }) => theme.colors.brand.secondary};
            border-color: ${({ theme }) => theme.colors.brand.primary};
          `;
        case 'danger':
          return css`
            color: ${({ theme }) => theme.colors.negative.primary};
            background-color: ${({ theme }) => theme.colors.negative.secondary};
            border-color: ${({ theme }) => theme.colors.negative.primary};
          `;
        case 'success':
          return css`
            color: ${({ theme }) => theme.colors.positive.primary};
            background-color: ${({ theme }) => theme.colors.positive.secondary};
            border-color: ${({ theme }) => theme.colors.positive.primary};
          `;
        case 'default':
        default:
          return css`
            color: ${({ theme }) => theme.colors.element.secondary};
            background-color: transparent;
            border-color: ${({ theme }) => theme.colors.divider.primary};
          `;
      }
    }
    switch (type) {
      case 'success':
        return css`
          background-color: ${({ theme }) => theme.colors.positive.primary};
          border-color: ${({ theme }) => theme.colors.positive.primary};
          color: ${({ theme }) => theme.colors.positive.overPrimary};

          &:focus {
            background-color: ${({ theme }) => theme.colors.positive.primary};
            border-color: ${({ theme }) => theme.colors.positive.primary};
            color: ${({ theme }) => theme.colors.positive.overPrimary};
          }

          &:hover {
            background-color: ${({ theme }) => theme.colors.positive.primary};
            border-color: ${({ theme }) => theme.colors.positive.primary};
            color: ${({ theme }) => theme.colors.positive.overPrimary};
          }
        `;
      case 'default':
      default:
        return css``;
    }
  }}
  ${(props) =>
    typeof props.iconLeft !== 'string' &&
    css`
      svg {
        width: 18px !important;
        height: 18px !important;
        margin-bottom: -2px;
        fill: ${({ type, ghost, theme }) => {
          if (ghost) {
            switch (type) {
              case 'primary':
                return `${theme.colors.brand.primary} !important`;
              case 'danger':
                return `${theme.colors.negative.primary} !important`;
              case 'success':
                return `${theme.colors.positive.primary} !important`;
              case 'default':
              default:
                return `${theme.colors.element.secondary} !important`;
            }
          }
          return '';
        }};
      }
    `}
`;

export default StyledButton;
